export const LIST_SERVICE_PRICE_REQUEST = 'LIST_SERVICE_PRICE_REQUEST'
export const LIST_SERVICE_PRICE_SUCCESS = 'LIST_SERVICE_PRICE_SUCCESS'
export const LIST_SERVICE_PRICE_FAIL = 'LIST_SERVICE_PRICE_FAIL'

export const LIST_SERVICE_PRICE_BRANCH_REQUEST = 'LIST_SERVICE_PRICE_BRANCH_REQUEST'
export const LIST_SERVICE_PRICE_BRANCH_SUCCESS = 'LIST_SERVICE_PRICE_BRANCH_SUCCESS'
export const LIST_SERVICE_PRICE_BRANCH_FAIL = 'LIST_SERVICE_PRICE_BRANCH_FAIL'

export const CREATE_SERVICE_PRICE_BRANCH_REQUEST = 'CREATE_SERVICE_PRICE_BRANCH_REQUEST'
export const CREATE_SERVICE_PRICE_BRANCH_SUCCESS = 'CREATE_SERVICE_PRICE_BRANCH_SUCCESS'
export const CREATE_SERVICE_PRICE_BRANCH_FAIL = 'CREATE_SERVICE_PRICE_BRANCH_FAIL'

export const CANCEL_SERVICE_PRICE_BRANCH_REQUEST = 'CANCEL_SERVICE_PRICE_BRANCH_REQUEST'
export const CANCEL_SERVICE_PRICE_BRANCH_SUCCESS = 'CANCEL_SERVICE_PRICE_BRANCH_SUCCESS'
export const CANCEL_SERVICE_PRICE_BRANCH_FAIL = 'CANCEL_SERVICE_PRICE_BRANCH_FAIL'

export const DETAIL_SERVICE_PRICE_BRANCH_REQUEST = 'DETAIL_SERVICE_PRICE_BRANCH_REQUEST'
export const DETAIL_SERVICE_PRICE_BRANCH_SUCCESS = 'DETAIL_SERVICE_PRICE_BRANCH_SUCCESS'
export const DETAIL_SERVICE_PRICE_BRANCH_FAIL = 'DETAIL_SERVICE_PRICE_BRANCH_FAIL'

export const UPDATE_SERVICE_PRICE_BRANCH_REQUEST = 'UPDATE_SERVICE_PRICE_BRANCH_REQUEST'
export const UPDATE_SERVICE_PRICE_BRANCH_SUCCESS = 'UPDATE_SERVICE_PRICE_BRANCH_SUCCESS'
export const UPDATE_SERVICE_PRICE_BRANCH_FAIL = 'UPDATE_SERVICE_PRICE_BRANCH_FAIL'

export const DELETE_SERVICE_PRICE_BRANCH_REQUEST = 'DELETE_SERVICE_PRICE_BRANCH_REQUEST'
export const DELETE_SERVICE_PRICE_BRANCH_SUCCESS = 'DELETE_SERVICE_PRICE_BRANCH_SUCCESS'
export const DELETE_SERVICE_PRICE_BRANCH_FAIL = 'DELETE_SERVICE_PRICE_BRANCH_FAIL'

export const IMPORT_SERVICE_PRICE_REQUEST = 'IMPORT_SERVICE_PRICE_REQUEST'
export const IMPORT_SERVICE_PRICE_SUCCESS = 'IMPORT_SERVICE_PRICE_SUCCESS'
export const IMPORT_SERVICE_PRICE_FAIL = 'IMPORT_SERVICE_PRICE_FAIL'

export const LIST_IMPORT_SERVICE_PRICE_REQUEST = 'LIST_IMPORT_SERVICE_PRICE_REQUEST'
export const LIST_IMPORT_SERVICE_PRICE_SUCCESS = 'LIST_IMPORT_SERVICE_PRICE_SUCCESS'
export const LIST_IMPORT_SERVICE_PRICE_FAIL = 'LIST_IMPORT_SERVICE_PRICE_FAIL'

export const LIST_DETAIL_IMPORT_SERVICE_PRICE_REQUEST = 'LIST_DETAIL_IMPORT_SERVICE_PRICE_REQUEST'
export const LIST_DETAIL_IMPORT_SERVICE_PRICE_SUCCESS = 'LIST_DETAIL_IMPORT_SERVICE_PRICE_SUCCESS'
export const LIST_DETAIL_IMPORT_SERVICE_PRICE_FAIL = 'LIST_DETAIL_IMPORT_SERVICE_PRICE_FAIL'

export const DETAIL_IMPORT_SERVICE_PRICE_REQUEST = 'DETAIL_IMPORT_SERVICE_PRICE_REQUEST'
export const DETAIL_IMPORT_SERVICE_PRICE_SUCCESS = 'DETAIL_IMPORT_SERVICE_PRICE_SUCCESS'
export const DETAIL_IMPORT_SERVICE_PRICE_FAIL = 'DETAIL_IMPORT_SERVICE_PRICE_FAIL'

export const EXPORT_IMPORT_SERVICE_PRICE_REQUEST = 'EXPORT_IMPORT_SERVICE_PRICE_REQUEST'
export const EXPORT_IMPORT_SERVICE_PRICE_SUCCESS = 'EXPORT_IMPORT_SERVICE_PRICE_SUCCESS'
export const EXPORT_IMPORT_SERVICE_PRICE_FAIL = 'EXPORT_IMPORT_SERVICE_PRICE_FAIL'

export const EXPORT_ALL_IMPORT_SERVICE_PRICE_REQUEST = 'EXPORT_ALL_IMPORT_SERVICE_PRICE_REQUEST'
export const EXPORT_ALL_IMPORT_SERVICE_PRICE_SUCCESS = 'EXPORT_ALL_IMPORT_SERVICE_PRICE_SUCCESS'
export const EXPORT_ALL_IMPORT_SERVICE_PRICE_FAIL = 'EXPORT_ALL_IMPORT_SERVICE_PRICE_FAIL'

export const CLEAR_IMPORT_SERVICE_PRICE = 'CLEAR_IMPORT_SERVICE_PRICE'


export const RESET_SERVICE_PRICE_BRANCH = 'RESET_SERVICE_PRICE_BRANCH'